import axios from "axios";
import { useNavigate } from "react-router-dom";

export const getCompanyData = async (companyID) => {
  try {
    const response = await fetch(
      "https://ahmedaglan.github.io/ClientsJSON/Clients.json"
    )
      .then((data) => data.json())
      .then((data) => {
        const founded = data.ClientsList.find(
          (company) => company.ClientID === companyID
        );
        if (!founded) throw Error("cannot find companyID");
        return founded;
      });
    //   https://vsoft.com-eg.net/VSoftDemoAPI/api/RunnerUsers/V6/Login
    return {
      ...response,
      baseURL: `${response.APIHost}${response.APIPath}api/RunnerUsers/V${response?.ApiVersion}`,
    };
  } catch (err) {
    throw err;
  }
};

export const handleLogin = async (baseURL, loginData, cb) => {
  const { companyID, username, password } = loginData;
  let response = "should change";
  try {
    console.log(baseURL);

    response = await fetch(`${baseURL}/Login`, {
      method: "post",
      body: JSON.stringify({ userName: username, password }),
      headers: {
        companyID: companyID,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((data) => data.json())
      .then((data) => {
        if (data.Message) {
          throw new Error(data.Message);
        } else {
          cb({ ...data, baseURL, companyID });
          localStorage.setItem(
            "runnerData",
            JSON.stringify({ ...data, baseURL, companyID })
          );
          return { data, baseURL, companyID };
        }
        return response;
      });
  } catch (err) {
    throw err;
  }
};

export const handleConfirm = async (runnerData, setRunnerData, shipments) => {
  const { baseURL, runnerId, accessToken, companyID } = runnerData;
  try {
    const response = await fetch(`${baseURL}/ConfirmAWBs/${runnerId}`, {
      method: "post",
      body: JSON.stringify({ awBs: shipments }),
      headers: {
        companyID: companyID,
        accessToken: accessToken,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    handleLogout(baseURL, setRunnerData, accessToken, runnerId);
    console.log(shipments);
    return response;
  } catch (err) {
    console.error(err);
    handleLogout(baseURL, setRunnerData, accessToken, runnerId);
  }
};

export const ConfirmPickupShipments = async (
  runnerData,
  setRunnerData,
  shipments
) => {
  const { baseURL, runnerId, accessToken, companyID } = runnerData;

  try {
    const response = await axios.post(
      `${baseURL}/ConfirmPickupShipments/${runnerId}`,
      shipments,
      {
        headers: {
          companyID: companyID,
          accessToken: accessToken,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    handleLogout(baseURL, setRunnerData, accessToken, runnerId);
    console.log(shipments);
    return response;
  } catch (err) {
    console.error(err);
    handleLogout(baseURL, setRunnerData, accessToken, runnerId);
  }
};

export const handleCheck = async (runnerData, setRunnerData) => {
  console.log(runnerData);
  const { baseURL, runnerId, accessToken, companyID } = runnerData;
  try {
    const response = await fetch(`${baseURL}/ConfirmAWBs/${runnerId}`, {
      method: "post",
      body: JSON.stringify({ awBs: [] }),
      headers: {
        companyID: companyID,
        accessToken: accessToken,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    if (response.status === 401) {
      setRunnerData(null);
      localStorage.removeItem("runnerData");
    }

    return response;
  } catch (err) {
    console.error(err);
  }
};

export const handleLogout = async (
  baseURL,
  cb,
  accessToken,
  runnerId,
  companyID
) => {
  try {
    const response = await fetch(`${baseURL}/Logout/${runnerId}`, {
      method: "post",
      body: {},
      headers: {
        companyID: companyID,
        Accept: "application/json",
        "Content-Type": "application/json",
        accessToken: accessToken,
      },
    })
      .then((data) => data.json())
      .then((data) => {
        cb(null);
        localStorage.removeItem("runnerData");
      });
  } catch (err) {
    throw err;
  }
};

export const handleRunnerData = (navigate) => ({
  login: async (formState, setRunnerData) => {
    try {
      const response = await fetch(
        "https://vsoftrunners.com-eg.net/api/RunnerUsers/V7/Login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            companyID: "241701",
          },
          body: JSON.stringify({
            username: formState.username,
            password: formState.password,
          }),
        }
      );

      let data;
      try {
        data = await response.json();
      } catch (jsonError) {
        console.error("Error parsing JSON:", jsonError);
        throw new Error("Invalid response from server.");
      }

      // ✅ تحقق من accessToken في الـ root مباشرة
      if (!response.ok || !data?.accessToken) {
        console.warn("Response OK but no accessToken. Full response:", data);
        throw new Error("Login failed due to missing access token.");
      }

      const userData = data;

      setRunnerData(userData);
      localStorage.setItem("accessToken", userData.accessToken);
      localStorage.setItem("roleID", userData.roleID); // لو مش موجود تجاهله أو خليه null
      localStorage.setItem("companyID", String(userData.companyID));
      localStorage.setItem("runnerId", userData.runnerId);

      navigate("/");
    } catch (error) {
      console.error("Login error:", error.message);
      alert("Login failed. Please check your credentials.");
    }
  },
});
